// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Raleway:wght@500;600;700&family=Lato:ital,wght@0,400;0,700;0,900;1,400;1,700;1,900&family=Poppins:ital,wght@0,400;0,700;1,700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
#root,
.App {
  height: 100%;
  font-size: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-smooth: never;
}
html,
body {
  background-color: #fff;
}
body {
  overflow-x: hidden;
  font-family: "Montserrat", sans-serif;
  font-size: 1rem;
  line-height: 1.75;
}
body.gray6,
html.gray6 {
  background-color: #f2f2f2;
}
body.modal-open {
  overflow: hidden;
}
a {
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
::focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.5);
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Raleway", sans-serif;
}
.no-data {
  font-weight: 600;
  margin-top: 1.313rem;
}
.brand-blue {
  color: #0074f2;
}
.custom-modal-backdrop.show {
  background-color: #fff;
  opacity: 0.8;
}
.bg-gray4 {
  background: #bdbdbd !important;
}
.max-width-520,
.mw520 {
  max-width: 520px;
}
.mw110 {
  max-width: 110px;
}
.minw110 {
  min-width: 110px;
}
.mw580 {
  max-width: 580px;
}
.was-validated .form-select:invalid:not([multiple]):not([size]),
.was-validated .form-select:invalid:not([multiple])[size="1"],
.form-select.is-invalid:not([multiple]):not([size]),
.form-select.is-invalid:not([multiple])[size="1"],
.was-validated .form-control:invalid,
.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem) !important;
  background-image: none;
  background-repeat: no-repeat !important;
  background-position: right calc(0.375em + 0.1875rem) center !important;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) !important;
}
.was-validated .form-control:valid,
.form-control.is-valid {
  background-image: none;
}
.was-validated .form-control:invalid:focus,
.form-control.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25) !important;
}
.form-floating > .form-control:not(:-moz-placeholder-shown) ~ label {
  opacity: 1;
  transform: scale(0.75) translateY(-0.25rem) translateX(0.73rem);
}
.form-floating > .form-control:focus ~ label,
.form-floating > .form-control:not(:placeholder-shown) ~ label,
.form-floating > .form-select ~ label {
  opacity: 1;
  transform: scale(0.75) translateY(-0.25rem) translateX(0.73rem);
}
.btn {
  border-width: 2px;
  border-radius: 6px;
  height: 51px;
}
.zIndex1 {
  position: relative !important;
  z-index: 1 !important;
}
.width-max-content {
  width: -moz-max-content !important;
  width: max-content !important;
}
.w-fit-content {
  width: -moz-fit-content !important;
  width: fit-content !important;
}
.no-decorate {
  text-decoration: none;
}
.no-decorate:hover {
  text-decoration: none;
}
.cursor-pointer {
  cursor: pointer;
}
span {
  line-height: 1.2;
}
p {
  font-style: normal;
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.75;
}
p.fs18 {
  font-style: normal;
  font-weight: normal;
  font-size: 1.125rem;
  line-height: 1.3333333;
}
.fs14 {
  font-size: 0.875rem;
}
.fs16 {
  font-size: 1rem;
}
.fs18 {
  font-size: 1.125rem !important;
}
.lh28 {
  line-height: 1.75;
}
.fs20 {
  font-size: 1.25rem !important;
}
.fs24 {
  font-size: 1.5rem;
  line-height: 1.3333333;
}
.fw500 {
  font-weight: 500 !important;
}
.fw700 {
  font-weight: 700 !important;
}
.fw600 {
  font-weight: 600 !important;
}
.note-color {
  color: #666;
}
.word-break-break-all {
  word-break: break-all;
}
@media print {
  .no-print {
    display: none !important;
  }
  html,
  body,
  #root {
    height: auto;
  }
}

@page {
  size: A4 portrait;
}
`, "",{"version":3,"sources":["webpack://./client/theme/main.css"],"names":[],"mappings":"AACA;;;;EAIE,YAAY;EACZ,eAAe;EACf,mCAAmC;EACnC,kCAAkC;EAClC,kBAAkB;AACpB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,4CAA4C;AAC9C;AACA;;;;;;EAME,kCAAkC;AACpC;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;AACA;EACE,cAAc;AAChB;AACA;EACE,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,8BAA8B;AAChC;AACA;;EAEE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;;;;;EAME,+CAA+C;EAC/C,sBAAsB;EACtB,uCAAuC;EACvC,sEAAsE;EACtE,2EAA2E;AAC7E;AACA;;EAEE,sBAAsB;AACxB;AACA;;EAEE,4DAA4D;AAC9D;AACA;EACE,UAAU;EACV,+DAA+D;AACjE;AACA;;;EAGE,UAAU;EACV,+DAA+D;AACjE;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,6BAA6B;EAC7B,qBAAqB;AACvB;AACA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,kCAAkC;EAClC,6BAA6B;AAC/B;AACA;EACE,qBAAqB;AACvB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE;IACE,wBAAwB;EAC1B;EACA;;;IAGE,YAAY;EACd;AACF;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":["@import \"https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700&family=Raleway:wght@500;600;700&family=Lato:ital,wght@0,400;0,700;0,900;1,400;1,700;1,900&family=Poppins:ital,wght@0,400;0,700;1,700&display=swap\";\nhtml,\nbody,\n#root,\n.App {\n  height: 100%;\n  font-size: 100%;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  font-smooth: never;\n}\nhtml,\nbody {\n  background-color: #fff;\n}\nbody {\n  overflow-x: hidden;\n  font-family: \"Montserrat\", sans-serif;\n  font-size: 1rem;\n  line-height: 1.75;\n}\nbody.gray6,\nhtml.gray6 {\n  background-color: #f2f2f2;\n}\nbody.modal-open {\n  overflow: hidden;\n}\na {\n  text-decoration: none;\n}\na:hover {\n  text-decoration: underline;\n}\n::focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.5);\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: \"Raleway\", sans-serif;\n}\n.no-data {\n  font-weight: 600;\n  margin-top: 1.313rem;\n}\n.brand-blue {\n  color: #0074f2;\n}\n.custom-modal-backdrop.show {\n  background-color: #fff;\n  opacity: 0.8;\n}\n.bg-gray4 {\n  background: #bdbdbd !important;\n}\n.max-width-520,\n.mw520 {\n  max-width: 520px;\n}\n.mw110 {\n  max-width: 110px;\n}\n.minw110 {\n  min-width: 110px;\n}\n.mw580 {\n  max-width: 580px;\n}\n.was-validated .form-select:invalid:not([multiple]):not([size]),\n.was-validated .form-select:invalid:not([multiple])[size=\"1\"],\n.form-select.is-invalid:not([multiple]):not([size]),\n.form-select.is-invalid:not([multiple])[size=\"1\"],\n.was-validated .form-control:invalid,\n.form-control.is-invalid {\n  padding-right: calc(1.5em + 0.75rem) !important;\n  background-image: none;\n  background-repeat: no-repeat !important;\n  background-position: right calc(0.375em + 0.1875rem) center !important;\n  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem) !important;\n}\n.was-validated .form-control:valid,\n.form-control.is-valid {\n  background-image: none;\n}\n.was-validated .form-control:invalid:focus,\n.form-control.is-invalid:focus {\n  box-shadow: 0 0 0 0.25rem rgba(220, 53, 69, 0.25) !important;\n}\n.form-floating > .form-control:not(:-moz-placeholder-shown) ~ label {\n  opacity: 1;\n  transform: scale(0.75) translateY(-0.25rem) translateX(0.73rem);\n}\n.form-floating > .form-control:focus ~ label,\n.form-floating > .form-control:not(:placeholder-shown) ~ label,\n.form-floating > .form-select ~ label {\n  opacity: 1;\n  transform: scale(0.75) translateY(-0.25rem) translateX(0.73rem);\n}\n.btn {\n  border-width: 2px;\n  border-radius: 6px;\n  height: 51px;\n}\n.zIndex1 {\n  position: relative !important;\n  z-index: 1 !important;\n}\n.width-max-content {\n  width: -moz-max-content !important;\n  width: max-content !important;\n}\n.w-fit-content {\n  width: -moz-fit-content !important;\n  width: fit-content !important;\n}\n.no-decorate {\n  text-decoration: none;\n}\n.no-decorate:hover {\n  text-decoration: none;\n}\n.cursor-pointer {\n  cursor: pointer;\n}\nspan {\n  line-height: 1.2;\n}\np {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 1rem;\n  line-height: 1.75;\n}\np.fs18 {\n  font-style: normal;\n  font-weight: normal;\n  font-size: 1.125rem;\n  line-height: 1.3333333;\n}\n.fs14 {\n  font-size: 0.875rem;\n}\n.fs16 {\n  font-size: 1rem;\n}\n.fs18 {\n  font-size: 1.125rem !important;\n}\n.lh28 {\n  line-height: 1.75;\n}\n.fs20 {\n  font-size: 1.25rem !important;\n}\n.fs24 {\n  font-size: 1.5rem;\n  line-height: 1.3333333;\n}\n.fw500 {\n  font-weight: 500 !important;\n}\n.fw700 {\n  font-weight: 700 !important;\n}\n.fw600 {\n  font-weight: 600 !important;\n}\n.note-color {\n  color: #666;\n}\n.word-break-break-all {\n  word-break: break-all;\n}\n@media print {\n  .no-print {\n    display: none !important;\n  }\n  html,\n  body,\n  #root {\n    height: auto;\n  }\n}\n\n@page {\n  size: A4 portrait;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
